// SoundContext.jsx
import { createContext, useContext, useState } from 'react';

// @ts-ignore
const SoundContext = createContext();

// @ts-ignore
export const SoundProvider = ({ children }) => {
    const [muted, setMuted] = useState(true);

    const toggleMuted = () => setMuted(prev => !prev);

    return (
        <SoundContext.Provider value={{ muted, toggleMuted }}>
            {children}
        </SoundContext.Provider>
    );
};

export const useSound = () => useContext(SoundContext);
